(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('TkbTransferInfoDialogController', TkbTransferInfoDialogController);

    TkbTransferInfoDialogController.$inject = ['$uibModalInstance', '$timeout', 'entity', 'myID', 'customer'];

    function TkbTransferInfoDialogController($uibModalInstance, $timeout, entity, myID, customer) {
        var vm = this;
        vm.payment = entity;
        vm.myID = myID;
        vm.customer = customer;
        vm.cancel = cancel;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        $timeout(function () {
            new Clipboard('.mt-clipboard');
        }, 100);
    }
})();
